/// <amd-module name="VSSUI/Components/Dialog/CornerDialog" />
import * as React from "react";

import { DialogInternal } from "./DialogInternal";
import { ICornerDialogProps } from "VSSUI/Components/Dialog/Dialog.Props";

import { ContentJustification, ContentLocation } from "VSSUI/Callout";
import { css } from "VSSUI/Util";

export class CornerDialog extends React.Component<ICornerDialogProps> {
    public render(): JSX.Element {
        return (
            <DialogInternal
                {...this.props}
                calloutContentClassName={css(this.props.calloutContentClassName, "bolt-lower-right-corner-dialog-content")}
                calloutClassName={css(this.props.calloutClassName, "no-events")}
                contentJustification={ContentJustification.End}
                contentLocation={ContentLocation.End}
                lightDismiss={false}
                modal={false}
                escDismiss={false}
                showCloseButton={true}
            />
        );
    }
}
